export default "__VITE_ASSET__CnY1d2M1__"